import {Component, OnInit} from '@angular/core';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {map} from 'rxjs/operators';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {group} from '@angular/animations';
import {LibraryItemGroup} from '@features/global-tax-calculator/models/gtc.models';
import {FileManagementService} from '@core/services/file-management.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {SnackBarService} from '@core/services/snack-bar.service';
import {GlobalTaxCalculatorServices} from '@features/global-tax-calculator/services/global-tax-calculator.services';
import {ActivatedRoute} from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-gtc-library',
    templateUrl: './gtc-library.component.html',
    styleUrls: ['./gtc-library.component.scss']
})
export class GtcLibraryComponent implements OnInit {

    constructor(private platformQueryService: PlatformQueryService,
                private fileManagementService: FileManagementService,
                private fuseSplashScreenService: FuseSplashScreenService,
                private snackbarService: SnackBarService,
                private gtcService: GlobalTaxCalculatorServices,
                private route: ActivatedRoute) {
    }

    itemGroups: LibraryItemGroup[];
    loaded = false;
    refresh = new Subject<void>();
    pdfSrc: string;
    public stream: any;

    ngOnInit(): void {
        this.route.params.subscribe(
            (params: any) => {
                if (params.category) {
                    const category = params.category;
                    const query = new PlatformQuery();
                    query.api = Api.Spreadsheet;
                    query.name = 'GtcLibraryItemsQuery';
                    query.setValue('Category', category);

                    this.platformQueryService.executeQuery(query).subscribe(response => {
                        const groups = response.fieldValues['LibraryItemsGroup'] as LibraryItemGroup[];
                        this.itemGroups = groups;
                        console.log('Item Groups', this.itemGroups);
                        if (this.itemGroups.length) {
                            this.clicked(this.itemGroups[0].items[0]);
                        }
                    });
                }
            });
    }

    clicked(item) {
        for (const itemGroup of this.itemGroups) {
            itemGroup.items.forEach(d => d.isActive = item.id === d.id);
        }
        this.loaded = false;
        this.fuseSplashScreenService.show();
        this.gtcService.getEmbeddedUrl(item.relativePath).subscribe(stream => {
            if (stream === 'File not found') {
                this.fuseSplashScreenService.hide();
                this.snackbarService.showError(stream.toString());
                return;
            }
            this.loaded = true;
            this.stream = stream;
            this.fuseSplashScreenService.hide();
        }, err => {
            console.log('Error ', err);
        });
    }

    downloadPdf(file: Blob) {
        for (const itemGroup of this.itemGroups) {
            const activeItem = itemGroup.items.find(d => d.isActive === true);
            if (activeItem) {
                this.fileManagementService.openSaveFileWindow(file, activeItem.title);
                break;
            }
        }
    }

}
